export default __webpack_public_path__ + "static/media/necromancer_white_icon.a7f87baa.png";